import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  Put,
} from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const PostersEndpoint = {
  getPosters: `/admin/homePageBanner/list`,
  // getPosterbyId: `/admin/homePageBanner/details/`,
  addPoster: `/admin/homePageBanner/add/`,
  editPoster: `/admin/homePageBanner/edit/`,
  deletePoster: `/admin/homePageBanner/delete/`,
  uploadImage: `/admin/homePageBanner/uploadImage`
};

export const getPosters = (param = "") => {
  const url = getAPIUrl(PostersEndpoint.getPosters, param);
  return Get(HomePageService, url, true);
};

// export const getPosterbyId = (param = "") => {
//   const url = getAPIUrl(PostersEndpoint.getPosterbyId, param);
//   return Get(HomePageService, url, true);
// };

export const addPoster = (data, param = "") => {
  const url = getAPIUrl(PostersEndpoint.addPoster, param);
  return Post(HomePageService, url, data, true);
};

export const editPoster = (data, param = "") => {
  const url = getAPIUrl(PostersEndpoint.editPoster, param);
  return Put(HomePageService, url, data, true);
};

export const deletePoster = (param = "") => {
  const url = getAPIUrl(PostersEndpoint.deletePoster, param);
  return Delete(HomePageService, url, param);
};

export const uploadImage = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k) => {
    if (data[k]) {
      formData.append(k, data[k]);
    }
  });
  const url = getAPIUrl(PostersEndpoint.uploadImage);
  return Post(HomePageService, url, formData, true, true);
};